import React, { useMemo } from 'react';
import { nanoid } from 'nanoid';

import LineBreak from './LineBreak';
import Error from './Error';

const withError = Component => React.forwardRef((props, ref) => {
  const {
    error,
    name,
    id,
  } = props;

  const errorId = useMemo(() => `error-${name}-${id || nanoid()}`, [id, name]);

  return (
    <React.Fragment>
      <Component
        {...props}
        aria-describedby={errorId}
        aria-invalid={!!error}
        isError={!!error}
        ref={ref}
      />
      <LineBreak />
      <Error id={errorId} className="error" isError={!!error}>
        { error && error.message }
      </Error>
    </React.Fragment>
  );
});

export default withError;
